import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import { MyProSidebarProvider } from './global/sidebar/sidebarContext';
import Topbar from './global/Topbar';

const ProtectedRoute = ({ children, cambiarColor }) => {
    const auth = UserAuth();
    const user = auth && auth.user; // Verificar si auth está definido antes de desestructurar user

    if (!user) {
        return <Navigate to="/" />;
    }

    return (
        <MyProSidebarProvider>
            <div style={{ height: "100%", width: "100%" }}>
                <main>
                    <Topbar cambiarColor={cambiarColor} />
                    {children}
                </main>
            </div>
        </MyProSidebarProvider>
    );
}

export default ProtectedRoute;